import React from 'react'

const IframeContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    return (
        <div className={`${containerObject.attributes.class}`}>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
            {containerObject.articles && containerObject.articles ? containerObject.articles.map((iframe) => {
                    return (
                        <>
                            <div>
                                <iframe className={`${iframe.attributes.class}`} src={iframe.attributes.linkUrl} width="" height="" frameborder="0.5">
                                </iframe>
                            </div>
                            </>
                    )
                }) : ''}
            </div>
            </div>

    )
}

export default IframeContainer